import { ActionTypes } from '../actions';

interface ITest {
    error: any;
    userData?: any;
    info: any;
    active?: any;
    loginMessage?: string | null;
}

const initialState: ITest = {
    error: null,
    active: null,
    info: null,
    loginMessage: null,
};
const userReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case ActionTypes.LOGIN_REQUEST:
            return {
                ...state,
            };
        case ActionTypes.LOGIN_SUCCESS:
            return {
                ...state,
                error: null,
                userData: action.payload,
                loginMessage: action.payload?.message || null,
            };
        case ActionTypes.LOGIN_FAILURE:
            return {
                ...state,
                userData: null,
                error: action.payload,
                loginMessage: null,
            };
        case ActionTypes.ADD_INFO:
            return {
                ...state
            };
        case ActionTypes.PROCESS_INFO:
            return {
                ...state,
                info: action.payload,
            };
        case ActionTypes.LOGOUT:
            return {
                ...state,
                userData: null,
                error: null,
                info: null,
                loginMessage: null
            };
        case ActionTypes.HELLO_WORLD:
            return {
                ...state,
                info: 'Hello World'
            }
        default:
            if (!action.type.toString().includes('@')) {
                //console.error('Unknown action:', action);
            }
            return state;
    }
};

export default userReducer;